import { getNs } from 'common/i18n-config'
import { SETTINGS } from 'components/App/const'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { changeLocation } from 'store/app/actions'

import { ServiceItemProps } from '../components/service-item'
import { netsuiteStatusStore } from '../stores/netsuite-status'

const { t, useNsReady } = getNs(['pages/settings/service-linkage'])

export const useGetNetsuite = (): ServiceItemProps => {
  useNsReady()
  const dispatch = useDispatch()
  const isLinked = netsuiteStatusStore.useSlice(state => state.data?.is_linked)

  useEffect(() => {
    netsuiteStatusStore.setFilters({}, true)
  }, [])

  return useMemo(() => {
    return {
      isLinked,
      name: t('netsuite'),
      description: t('netsuite_description'),
      onClickSetting: () => dispatch(changeLocation(SETTINGS.NETSUITE_INTEGRATION_PATH)),
    }
  }, [dispatch, isLinked])
}
